const PREVIEW_FIRST = [
  'user-name',
  'user-id',
  'email-id',
  'mobile',
  'linux-group',
  'user-type',
  'user-details',
  'initial-pwd',
  'system-type',
  'tools',
  'vnc-fqdn',
  'putty-fqdn',
  'setup-date',
  'expiry-date',
  'duration',
];

function orderedColumns(columns = []) {
  const rest = columns.filter((key) => !PREVIEW_FIRST.includes(key));
  return [...PREVIEW_FIRST.filter((key) => columns.includes(key)), ...rest];
}

export default function PmaExcelPreview({ preview, loading }) {
  if (loading) {
    return <p className="text-sm theme-text-secondary">Building Excel preview…</p>;
  }
  if (!preview?.rows?.length) return null;

  const columns = orderedColumns(preview.columns || Object.keys(preview.rows[0] || {}));

  return (
    <div className="space-y-2">
      <h2 className="text-lg font-semibold theme-text">
        {preview.generate || preview.callsPma === false ? 'SMS lab generate' : 'Excel preview'}
      </h2>
      <p className="text-sm theme-text-secondary">
        Sheet <strong>{preview.sheet || 'users'}</strong>
        {preview.filename ? (
          <>
            {' '}
            · {preview.filename}
          </>
        ) : null}
        {' · '}
        {preview.rows.length} row{preview.rows.length === 1 ? '' : 's'}
        {preview.generate || preview.callsPma === false ? (
          <> · stored in SMS (pma_lab_users), not posted to PMA v2</>
        ) : null}
      </p>
      <div
        className="overflow-auto max-h-[28rem] rounded-lg border"
        style={{ borderColor: 'var(--color-border)' }}
      >
        <table className="min-w-max text-xs theme-text">
          <thead>
            <tr style={{ backgroundColor: '#1F4E79', color: '#fff' }}>
              {columns.map((key) => (
                <th key={key} className="px-2 py-2 text-left font-semibold whitespace-nowrap">
                  {key}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {preview.rows.map((row, index) => (
              <tr
                key={`${row['email-id'] || row['user-id'] || 'row'}-${index}`}
                style={{
                  backgroundColor:
                    index % 2 === 0 ? 'var(--color-surface)' : 'var(--color-surface-secondary)',
                }}
              >
                {columns.map((key) => (
                  <td key={key} className="px-2 py-1.5 whitespace-nowrap align-top">
                    {row[key] == null || row[key] === '' ? '—' : String(row[key])}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
